import { getClient } from '@/lib/restClient';
import { SortObject } from '@/pages/menu-managements/services/searchItem';
import { Title } from '@/pages/menu-managements/services/title';
import { Quantity } from '@/services/BrandOptionGroup';
import {
  BrandOptionGroupDelivery,
  BrandOptionGroupEatIn,
  BrandOptionGroupTakeout,
} from '@/services/BrandOptionGroup/hooks';
import { MenuManagementBrandOptionGroupService } from '@/services/BrandOptionGroup/MenuManagementOptionGroupService';

export type MenuManagementBrandOptionGroupCreateParams = {
  associate_brand_id: number;
  title: Title;
  memo: string | null;
  brand_item_sort_objects: SortObject[];
  takeout: BrandOptionGroupTakeout | null;
  eat_in: BrandOptionGroupEatIn | null;
  delivery: BrandOptionGroupDelivery | null;
  quantity: Quantity;
};

export const useMenuManagementCreateBrandOptionGroup = async (
  params: MenuManagementBrandOptionGroupCreateParams
): Promise<void> => {
  const menuManagementBrandOptionGroupService =
    new MenuManagementBrandOptionGroupService(getClient());

  return menuManagementBrandOptionGroupService.create(params);
};
